import { lazy } from 'react'
import { withSuspense } from 'utils/lazyLoad/lazyWrapper'

const Home = lazy(() => import('features/buyer/pages/Home'))
const Vehicle = lazy(() => import('features/buyer/pages/Vehicle'))
const ViewVehicle = lazy(
  () => import('features/buyer/pages/Vehicle/actions/View'),
)
const ViewehicleDetail = lazy(
  () => import('features/buyer/pages/Buy-now/actions/View'),
)

const Active = lazy(() => import('features/buyer/pages/Active'))
const ViewActive = lazy(
  () => import('features/buyer/pages/Active/actions/View'),
)

const BuyNowPage = lazy(() => import('features/buyer/pages/Buy-now'))
const ViewOfferNow = lazy(
  () => import('features/buyer/pages/Buy-now/actions/View'),
)

const Upcoming = lazy(() => import('features/buyer/pages/Upcoming'))
const ViewUpcoming = lazy(
  () => import('features/buyer/pages/Upcoming/actions/View'),
)

const Pending = lazy(() => import('features/buyer/pages/Pending'))
const ViewPending = lazy(
  () => import('features/buyer/pages/Pending/actions/View'),
)

const Awarded = lazy(() => import('features/buyer/pages/Awarded'))
const ViewAwarded = lazy(
  () => import('features/buyer/pages/Awarded/actions/View'),
)

const PurchasedSection = lazy(() => import('features/buyer/pages/Purchased'))
const ViewPurchased = lazy(
  () => import('features/buyer/pages/Purchased/actions/View'),
)

const BuyHistory = lazy(() => import('features/buyer/pages/History'))
const BuyesOfferList = lazy(
  () => import('features/buyer/components/Offers/List'),
)

const ViewProfile = lazy(
  () => import('features/profile/components/ViewProfile'),
)
const EditProfile = lazy(
  () => import('features/profile/components/EditProfile'),
)
const ChangePassword = lazy(
  () => import('features/profile/components/ChangePassword'),
)

const Announcement = lazy(
  () => import('features/notifications/components/Announcement'),
)
const Notification = lazy(
  () => import('features/notifications/components/Notification'),
)

const Sellerprofile = lazy(() => import('features/buyer/pages/SellerProfile'))
const SellerBankDetails = lazy(
  () => import('features/buyer/pages/SellerBankDetails'),
)

const Invoices = lazy(() => import('features/buyer/pages/Invoices'))
const ManagePayments = lazy(() => import('features/buyer/pages/ManagePayments'))
const AddBankAccountPage = lazy(
  () => import('features/buyer/pages/ManagePayments/AddBankAccount'),
)
const AddCreditCardPage = lazy(
  () => import('features/buyer/pages/ManagePayments/AddCreditCard'),
)

const Document = lazy(
  () => import('features/invoices/components/BillOfSale/Document'),
)
const SellerLogs = lazy(
  () => import('features/seller/pages/logs/SellerLogs.js'),
)

export const BuyerRoutes = [
  { path: '/', element: withSuspense(Home) },
  { path: '/vehicle', element: withSuspense(Vehicle) },
  { path: '/vehicle/:id', element: withSuspense(ViewVehicle) },
  { path: '/view/vehicle/:id', element: withSuspense(ViewehicleDetail) },

  { path: '/active', element: withSuspense(Active) },
  { path: '/active/:id', element: withSuspense(ViewActive) },

  { path: '/buy-it-now', element: withSuspense(BuyNowPage) },
  { path: '/buy-it-now/:id', element: withSuspense(ViewOfferNow) },

  { path: '/my-offers', element: withSuspense(BuyesOfferList) },

  { path: '/upcoming', element: withSuspense(Upcoming) },
  { path: '/upcoming/:id', element: withSuspense(ViewUpcoming) },

  { path: '/pending', element: withSuspense(Pending) },
  { path: '/pending/:id', element: withSuspense(ViewPending) },

  { path: '/awarded', element: withSuspense(Awarded) },
  { path: '/awarded/:id', element: withSuspense(ViewAwarded) },

  { path: '/purchased', element: withSuspense(PurchasedSection) },
  { path: '/purchased/:id', element: withSuspense(ViewPurchased) },

  { path: '/document/:id', element: withSuspense(Document) },

  { path: '/edit-profile', element: withSuspense(EditProfile) },
  { path: '/change-password', element: withSuspense(ChangePassword) },
  { path: '/profile', element: withSuspense(ViewProfile) },

  { path: '/buy-history', element: withSuspense(BuyHistory) },

  { path: '/announcement/:id', element: withSuspense(Announcement) },
  { path: '/notifications', element: withSuspense(Notification) },

  { path: '/seller/profile/:id', element: withSuspense(Sellerprofile) },
  {
    path: '/seller/bank/details/:id',
    element: withSuspense(SellerBankDetails),
  },

  { path: '/account/invoices', element: withSuspense(Invoices) },
  { path: '/manage-payments', element: withSuspense(ManagePayments) },
  {
    path: '/manage-payments/add-bank-account',
    element: withSuspense(AddBankAccountPage),
  },
  {
    path: '/manage-payments/add-credit-card',
    element: withSuspense(AddCreditCardPage),
  },

  { path: '/user-logs', element: withSuspense(SellerLogs) },
]
